export default "__VITE_ASSET__BGteGu6w__"